import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from "@angular/core";

@Injectable()
export class MatPaginatorIntlDe extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Artikel pro Seite';
  override nextPageLabel     = 'Nächste Seite';
  override previousPageLabel = 'Vorherige Seite';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 von ${length}`;
    }

    const actualLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, actualLength);

    return `${startIndex + 1} - ${endIndex} von ${actualLength}`;
  };
}
